import { useRef, useEffect } from 'react';
import { Container } from './Container';
import { useScrollReveal } from './useScrollReveal';
import { LEADERBOARD_EXAMPLE_ID } from '../data/gameExamples';

const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '') || '';
const exampleLeaderboardId = LEADERBOARD_EXAMPLE_ID;
const exampleLeaderboardUrl = `${base}/leaderboard/${exampleLeaderboardId}`;
const leaderboardVideoUrl = `${base}/demo-leaderboard.mp4`;
const leaderboardPosterUrl = `${base}/GameTypeImages/leaderboard.jpg`;

export function LiveActivations() {
  const [ref, isVisible] = useScrollReveal();
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (isVisible) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isVisible]);

  return (
    <section ref={ref} id="leaderboard" aria-label="Leaderboard section" className={`sf-section sf-section-screen py-10 sm:py-16 lg:py-20 relative z-10 landing-reveal ${isVisible ? 'visible' : ''}`}>
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-arcade tracking-tight text-gch-accent sm:text-4xl">The leaderboard keeps people playing</h2>
          <p className="mt-3 text-base text-gch-text-secondary max-w-2xl mx-auto">
            Scores update in real time, so players can chase the top spot. Use it as a live screen, a shared results link, or a simple reason to play again.
          </p>
        </div>
        <div id="live-leaderboard" className="mx-auto mt-8 sm:mt-10 w-full max-w-4xl">
          {/* TV mockup */}
          <div className="relative">
            <div className="relative rounded-xl sm:rounded-2xl border-[6px] sm:border-[10px] border-slate-800 bg-black shadow-2xl shadow-black/40 overflow-hidden">
              <video
                ref={videoRef}
                src={leaderboardVideoUrl}
                poster={leaderboardPosterUrl}
                loop
                muted
                playsInline
                preload="metadata"
                className="w-full h-auto block"
                aria-label="Live leaderboard demo"
              />
              {/* Subtle screen reflection */}
              <div className="absolute inset-0 pointer-events-none" style={{
                background: 'linear-gradient(165deg, rgba(255,255,255,0.03) 0%, transparent 40%)',
              }} />
            </div>
            {/* Display stand */}
            <div className="flex justify-center">
              <div className="w-24 sm:w-36 h-2 bg-slate-800 rounded-b-lg" />
            </div>
            <div className="flex justify-center -mt-px">
              <div className="w-36 sm:w-52 h-3 sm:h-4 bg-slate-700 rounded-b-xl" />
            </div>
          </div>
          <p className="mt-5 text-center text-sm font-semibold text-gch-text-secondary/60 uppercase tracking-wider">
            Live leaderboard example
          </p>
          <p className="mt-3 text-center hidden sm:block">
            <a href={exampleLeaderboardUrl} target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-gch-accent hover:text-gch-accent/80">
              Open live leaderboard example →
            </a>
          </p>
        </div>
      </Container>
    </section>
  );
}
